import FormComponent from '../../../../components/FormComponent';
import SelectorEngine from '../../../../utils/dom/selector-engine';
import EventHandler from '../../../../utils/dom/event-handler';

const RESET_BUTTON_SELECTOR = '.js-add-new-contact-reset-close';

class EditContactSummary extends FormComponent {
	getContactData(data = this.data) {
		if (typeof data?.getSelectedContact === 'function') {
			const selected = data.getSelectedContact();
			if (selected?.displayName || selected?.name) {
				return selected;
			}
		}

		const contactData = data?.contactData || {};
		if (contactData.displayName || contactData.name) {
			return contactData;
		}

		return {};
	}

	markup(_value, data = {}, titleMarkup) {
		const contactData = this.getContactData(data);
		const displayName = contactData.displayName || contactData.name || '';
		const membershipNumber = contactData.membershipNumber || contactData.ltaNumber || '';
		const resetButtonLabel = data.resetButtonLabel || 'Select a different contact';

		return `
			<div class="lta-edit-contact-summary">
				<div class="lta-edit-contact-summary__title">${titleMarkup}</div>
				${
					displayName
						? `
					<div class="lta-selected-contact-summary">
						<div class="lta-selected-contact-summary__content">
							<div class="lta-selected-contact-summary__content-name u-h6">${displayName}</div>
							${
								membershipNumber
									? `<div class="lta-selected-contact-summary__email u-body2 u-mt-1">${membershipNumber}</div>`
									: ''
							}
						</div>
						<button type="button" class="lta-btn lta-btn--xs lta-btn--petite lta-btn--icon lta-btn--icon-before js-add-new-contact-reset-close u-mt-2" aria-label="${resetButtonLabel}">
							<svg class="lta-icon js-lta-text-input--btn-icon u-mr-1" width="1.5em" height="1.5em" fill="currentColor" alt="search" aria-hidden="true">
								<use xlink:href="/static/images/icons/lta-icons.svg#close"></use>
							</svg>${resetButtonLabel}
						</button>
					</div>
				`
						: ''
				}
			</div>
		`;
	}

	afterRender() {
		const resetButton = SelectorEngine.findOne(RESET_BUTTON_SELECTOR, this.containerEl);
		if (resetButton) {
			EventHandler.on(resetButton, 'click', () => {
				this.data?.onSelectedContactReset?.();
				if (this.data?.closeOnReset) {
					this.closeForm();
				}
			});
		}

		this.emitValue();
	}

	closeForm() {
		if (typeof this.data?.closeForm === 'function') {
			this.data.closeForm();
			return;
		}

		if (typeof this.data?.exitButtonHandler === 'function') {
			this.data.exitButtonHandler();
			return;
		}

		if (typeof this.data?.exitWithoutSavingButtonHandler === 'function') {
			this.data.exitWithoutSavingButtonHandler();
		}
	}

	emitValue() {
		this.value = {
			id: this.data.id,
			fieldName: this.data.fieldName,
			value: this.getContactData(),
			contactData: this.getContactData()
		};
	}

	validate() {
		return true;
	}
}

export default EditContactSummary;
